import React, { useEffect } from "react";
import ActionTable from "./ActionTable";
import Tabs from "./Tabs";
import AccessDashboard from "./Accessdashboard";
import "./ActionTable.css";
import { useSearchParams } from "react-router-dom";

export default function Action() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab");

  useEffect(() => {
    if (!tab) {
      setSearchParams({ tab: "incidents" }, { replace: true });
    }
  }, []);

  const activeTab = tab === "access-management"
    ? "accessManagement"
    : "incidentManagement";

  const handleTabChange = (newTab) => {
    setSearchParams({
      tab: newTab === "accessManagement" ? "access-management" : "incidents"
    });
  };

  return (
    <div className="bg-[#eee] space-y-4 p-4">
      <Tabs activeTab={activeTab} setActiveTab={handleTabChange} />

      {activeTab === "incidentManagement" ? (
        <ActionTable />
      ) : (
        <AccessDashboard isAccessManagementOpen={true} />
      )}
    </div>
  );
}